import { render, staticRenderFns } from "./SuperAdminLogo.vue?vue&type=template&id=48408b7e&scoped=true&"
import script from "./SuperAdminLogo.vue?vue&type=script&lang=js&"
export * from "./SuperAdminLogo.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminLogo.vue?vue&type=style&index=0&id=48408b7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48408b7e",
  null
  
)

export default component.exports